import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ 'confirm', 'form', 'input', 'cancel', 'close' ];
  declare readonly hasCancelTarget: boolean;
  declare readonly cancelTarget: HTMLButtonElement;
  declare readonly confirmTarget: HTMLButtonElement;
  declare readonly formTarget: HTMLFormElement;
  declare readonly inputTarget: HTMLInputElement;
  declare readonly closeTarget: HTMLButtonElement;
  declare readonly hasCloseTarget: boolean;

  connect() {
    // Setup form listeners
    this.initFormListeners();
    this.inputTarget.focus()
  }

  toggleActions = (disabled: boolean) => {
    if (disabled) this.confirmTarget.setAttribute('disabled', 'disabled');
    else this.confirmTarget.removeAttribute('disabled');
    if (this.hasCancelTarget) {
      if (disabled) this.cancelTarget.setAttribute('disabled', 'disabled');
      else this.cancelTarget.removeAttribute('disabled');
    }
    if (this.hasCloseTarget) {
      if (disabled) this.closeTarget.setAttribute('disabled', 'disabled');
      else this.closeTarget.removeAttribute('disabled');
    }
  }

  initFormListeners = () => {
    // Remove any existing listeners
    this.formTarget.removeEventListener('turbo:submit-start', this.submitStart);
    this.formTarget.removeEventListener('turbo:submit-end', this.submitEnd);
    // Add new listeners
    this.formTarget.addEventListener('turbo:submit-start', this.submitStart);
    this.formTarget.addEventListener('turbo:submit-end', this.submitEnd);
  }

  submitStart = e => {
    this.toggleActions(true);
    this.confirmTarget.querySelector('.icon:not(.spinner)').classList.add('hidden');
    this.confirmTarget.querySelector('.icon.spinner').classList.remove('hidden');
  }

  submitEnd = e => {
    this.toggleActions(false);
    this.confirmTarget.querySelector('.icon:not(.spinner)').classList.remove('hidden');
    this.confirmTarget.querySelector('.icon.spinner').classList.add('hidden');
    this.initFormListeners();
  }

  input = e => {
    const value = e.target.value;
    if (value === 'confirm') {
      this.confirmTarget.classList.remove('disabled');
      this.confirmTarget.removeAttribute('disabled')
    }
    else {
      this.confirmTarget.classList.add('disabled');
      this.confirmTarget.setAttribute('disabled', 'disabled');
    }
  }

  submit = () => this.formTarget.requestSubmit();
}